import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=5df68b89&"
import script from "./ServiceInfo.vue?vue&type=script&lang=ts&"
export * from "./ServiceInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceInfo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
